<template>
  <z-dialogo ref="dialogo" titulo="Clientes" scrollable dividers no-padding largura="900px" altura="383px">

    <template v-slot:prepend>
      <v-toolbar flat color="white">
        <z-text-field-search
          v-model="busca"
          ref="busca"
          width="100%"
          select
          filled
          show-type
          autofocus
          @focus="is_busca_focused = true"
          @blur="is_busca_focused = false"
          @keydown.enter="buscar"
          @click:clear="limparBusca"
          @change:type="onChangeSearchType"
        ></z-text-field-search>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn small fab color="primary" class="ml-3 mr-1" v-on="on" @click="adicionar">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Adicionar Cliente</span>
        </v-tooltip>
      </v-toolbar>
    </template>

    <template v-slot:texto>
      <div ref="topo"></div>
      <z-loading :loading="carregando">

        <v-data-table
          mobile-breakpoint="0"
          disable-pagination
          disable-sort
          hide-default-footer
          :headers="headers"
          :items="itens_busca"
          :loading="carregando"
          fixed-header_
          height_="383px"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr
                v-for="(item, index) in items"
                ref="urls"
                :key="index"
                class="apontador noselect"
                :class="{'active': isActive(index)}"
                @click="selecionar(item)"
              >
                <td>{{ item.id }}</td>
                <td>{{ item.nome }}</td>
                <td class="text-no-wrap">{{ item.telefone }}</td>
                <td>{{ item.ultima_ordem_servico && item.ultima_ordem_servico.veiculo  ? item.ultima_ordem_servico.veiculo.placa : ''  }}</td>
                <td>{{ item.ultima_ordem_servico && item.ultima_ordem_servico.veiculo  ? item.ultima_ordem_servico.veiculo.modelo : ''  }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

      </z-loading>
    </template>

    <template v-slot:actions_left>
      <span class="text-subtitle-2">Clientes encontrados: {{ itens_busca.length }}</span>
    </template>
    <template v-slot:actions_right>
      <v-btn color="primary" @click="fechar()">Fechar</v-btn>
    </template>

  </z-dialogo>
</template>

<script>

import clientesApi from "@/app/services/clientes";
import { abrirJanela } from "@/app/helpers/utils";

import buscas_mixin from "@/app/mixins/buscas.js";

  export default {
    name: 'DialogoBuscarClientes',

    mixins: [buscas_mixin],

    props: {
      value: {
        type: String,
        default: ''
      },
    },

    data() {
      return {
        headers: [
          { text: "Código", value: "id", width: "100px" },
          { text: "Nome", value: "nome" },
          { text: "Telefone", value: "telefone" },
          { text: "Placa", value: "placa", width: "100px" },
          { text: "Modelo", value: "modelo" },
        ],
        search_type: 'contem',
      };
    },

    methods: {

      async buscar() {
        try {
          if (this.busca && this.busca.length > 0) {
            this.carregando = true;

            const filtros = {
              ...(this.search_type === "contem"
                ? { nome__contains: this.busca }
                : { nome__startswith: this.busca }),
              id__eq: this.busca,
              cpf_cnpj__eq: this.busca,
            };

            this.itens_busca = await clientesApi.buscar(filtros);
            this.atual = 0;
            setTimeout(() => {
              this.scrollList();
            }, 100);
          }
        } catch (error) {
          this.$eventbus.notificarErro('Não foi possível efetuar a busca.');
          console.error(error);
        } finally {
          this.carregando = false;
        }
      },

      adicionar() {
        abrirJanela(window.location.origin + '/#/cadastros/clientes/adicionar');
      },

      onChangeSearchType(value) {
        console.log(value);
        this.search_type = value;
        this.buscar();
      },

    },
  }
</script>

<style scoped>

</style>
